<template>
  <div class="admin-container">
    <!-- 侧边栏菜单 -->
    <aside class="sidebar">
      <div class="sidebar-header">
        <h1>赛事管理</h1>
      </div>

      <nav class="sidebar-menu">
        <ul>
          <li
              :class="{ active: $route.name === 'Banner' }"
              @click="$router.push('/dashboard/Banner')"
          >
            <span class="menu-text">首页banner</span>
          </li>
          <li
              :class="{ active: $route.name === 'ContestManagement' }"
              @click="$router.push('/dashboard/contestManagement')"
          >
            <span class="menu-text">主办单位</span>
          </li>
          <li
              :class="{ active: $route.name === 'Introduction' }"
              @click="$router.push('/dashboard/Introduction')"
          >
            <span class="menu-text">大赛简介</span>
          </li>
          <li
              :class="{ active: $route.name === 'Review' }"
              @click="$router.push('/dashboard/Review')"
          >
            <span class="menu-text">往届回顾</span>
          </li>
          <li
              :class="{ active: $route.name === 'Schedule' }"
              @click="$router.push('/dashboard/Schedule')"
          >
            <span class="menu-text">赛制赛程</span>
          </li>
          <li
              :class="{ active: $route.name === 'PlayerWayOut' }"
              @click="$router.push('/dashboard/PlayerWayOut')"
          >
            <span class="menu-text">选手出路</span>
          </li>
          <li
              :class="{ active: $route.name === 'Collaboration' }"
              @click="$router.push('/dashboard/Collaboration')"
          >
            <span class="menu-text">报名设置</span>
          </li>
          <li
              :class="{ active: $route.name === 'Register' }"
              @click="$router.push('/dashboard/Register')"
          >
            <span class="menu-text">报名管理</span>
          </li>
          <li    v-if="adminInfo && adminInfo.roleType === 1"
              :class="{ active: $route.name === 'SystemAdmin' }"
              @click="$router.push('/dashboard/SystemAdmin')"
          >
            <span class="menu-text">公司管理</span>
          </li>
        </ul>
      </nav>

      <div class="sidebar-footer">
        <button class="logout-btn" @click="handleLogout">
          <span>🚪</span> 退出登录
        </button>
      </div>
    </aside>

    <!-- 主内容区 -->
    <main class="main-content">
      <header class="content-header">
        <h2>{{ getPageTitle() }}</h2>
        <div class="user-info">
          <span>管理员</span>
        </div>
      </header>

      <div class="content-body">
        <router-view />
      </div>
    </main>
  </div>
</template>

<script setup>
import { useRouter, } from 'vue-router'
import { ref, onMounted } from 'vue';

const router = useRouter()
const adminInfo = ref(null);
// 获取页面标题
const getPageTitle = () => {
  switch (router.currentRoute.value.name) {
    case 'ContestManagement':
      return '赛事管理'
    case 'PlayerManagement':
      return '选手管理'
    case 'ResultsManagement':
      return '成绩管理'
    default:
      return '控制台'
  }
}
const getAdminInfo = () => {
  const adminData = localStorage.getItem('systemAdmin');
  if (adminData) {
    try {
      adminInfo.value = JSON.parse(adminData);
    } catch (error) {
      console.error('解析管理员信息失败:', error);
    }
  }
};
// 退出登录
const handleLogout = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('systemAdmin')
  router.push('/login')
}

onMounted(() => {
  getAdminInfo();
});
</script>

<style scoped>
.admin-container {
  display: flex;
  min-height: 100vh;
  background-color: #f5f7fa;
}

/* 侧边栏样式 */
.sidebar {
  width: 240px;
  background-color: #2c3e50;
  color: white;
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: fixed;

  .sidebar-header {
    padding: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    h1 {
      margin: 0;
      font-size: 18px;
      text-align: center;
    }
  }

  .sidebar-menu {
    flex: 1;
    padding-top: 20px;

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        padding: 12px 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: background-color 0.3s;

        &:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }

        &.active {
          background-color: #E6398B;
        }

        .menu-icon {
          margin-right: 10px;
          font-size: 18px;
        }

        .menu-text {
          font-size: 14px;
        }
      }
    }
  }

  .sidebar-footer {
    padding: 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);

    .logout-btn {
      width: 100%;
      padding: 10px;
      background-color: transparent;
      color: white;
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 4px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      transition: all 0.3s;

      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
  }
}

/* 主内容区样式 */
.main-content {
  flex: 1;
  margin-left: 240px;
  width: calc(100% - 240px);

  .content-header {
    padding: 20px 30px;
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    h2 {
      margin: 0;
      font-size: 20px;
      color: #333;
    }

    .user-info {
      color: #666;
      font-size: 14px;
    }
  }

  .content-body {
    padding: 30px;
  }
}

/* 响应式适配 */
@media (max-width: 768px) {
  .sidebar {
    width: 60px;

    .sidebar-header h1,
    .menu-text,
    .sidebar-footer span:not(:first-child) {
      display: none;
    }

    .sidebar-menu li {
      justify-content: center;

      .menu-icon {
        margin-right: 0;
      }
    }

    .sidebar-footer {
      padding: 15px 0;

      .logout-btn {
        justify-content: center;
      }
    }
  }

  .main-content {
    margin-left: 60px;
    width: calc(100% - 60px);
  }
}
</style>